class ImageSlider {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[id^="SliderTrack-"]');
    this.slides = Array.from(this.track.children);
    this.dots = Array.from(container.querySelectorAll('.image-slider__dot'));
    this.prevBtn = container.querySelector('.image-slider__arrow--prev');
    this.nextBtn = container.querySelector('.image-slider__arrow--next');

    this.currentIndex = 0;
    this.slideCount = this.slides.length;
    this.autoplay = container.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5000;
    this.autoplayTimer = null;

    // Touch/drag state
    this.isDragging = false;
    this.startX = 0;
    this.currentTranslate = 0;

    this.markMobileSlides();
    this.bindEvents();
    this.goTo(0, false);

    if (this.autoplay && this.slideCount > 1) {
      this.startAutoplay();
    }
  }

  markMobileSlides() {
    this.slides.forEach((slide) => {
      const mobileImg = slide.querySelector('.image-slider__image--mobile');
      if (mobileImg) {
        slide.setAttribute('data-has-mobile', 'true');
      }
    });
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prev();
        this.restartAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.next();
        this.restartAutoplay();
      });
    }

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    // Pause on hover (desktop)
    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });

    // Touch / swipe support
    const viewport = this.container.querySelector('.image-slider__viewport');

    viewport.addEventListener('touchstart', (e) => this.onDragStart(e.touches[0].clientX), { passive: true });
    viewport.addEventListener('touchmove', (e) => this.onDragMove(e.touches[0].clientX), { passive: true });
    viewport.addEventListener('touchend', () => this.onDragEnd());

    viewport.addEventListener('mousedown', (e) => {
      e.preventDefault();
      this.onDragStart(e.clientX);
    });
    window.addEventListener('mousemove', (e) => {
      if (this.isDragging) this.onDragMove(e.clientX);
    });
    window.addEventListener('mouseup', () => this.onDragEnd());

    // Keyboard accessibility
    this.container.setAttribute('tabindex', '0');
    this.container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });

    // Recalculate on resize
    window.addEventListener('resize', () => this.goTo(this.currentIndex, false));
  }

  onDragStart(clientX) {
    this.isDragging = true;
    this.startX = clientX;
    this.track.style.transition = 'none';
  }

  onDragMove(clientX) {
    if (!this.isDragging) return;
    const diff = clientX - this.startX;
    const width = window.innerWidth;
    this.currentTranslate = -this.currentIndex * width + diff;
    this.track.style.transform = `translateX(${this.currentTranslate}px)`;
  }

  onDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.style.transition = '';

    const width = window.innerWidth;
    const moved = this.currentTranslate + this.currentIndex * width;

    if (moved < -width * 0.2) {
      this.next();
    } else if (moved > width * 0.2) {
      this.prev();
    } else {
      this.goTo(this.currentIndex);
    }

    this.restartAutoplay();
  }

  goTo(index, animate = true) {
    if (index < 0) index = this.slideCount - 1;
    if (index >= this.slideCount) index = 0;

    this.currentIndex = index;
    const width = window.innerWidth;

    if (!animate) {
      this.track.style.transition = 'none';
    } else {
      this.track.style.transition = '';
    }

    this.track.style.transform = `translateX(${-index * width}px)`;

    if (!animate) {
      // Force reflow to apply the "none" transition before re-enabling it
      requestAnimationFrame(() => {
        this.track.style.transition = '';
      });
    }

    this.updateDots();
  }

  updateDots() {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.currentIndex);
    });
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  prev() {
    this.goTo(this.currentIndex - 1);
  }

  startAutoplay() {
    this.stopAutoplay();
    if (this.slideCount <= 1) return;
    this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay) {
      this.startAutoplay();
    }
  }
}

function initImageSliders() {
  document.querySelectorAll('.image-slider').forEach((container) => {
    if (!container.dataset.sliderInitialized) {
      container.dataset.sliderInitialized = 'true';
      new ImageSlider(container);
    }
  });
}

document.addEventListener('DOMContentLoaded', initImageSliders);

// Re-init when section is added/edited in the theme editor
document.addEventListener('shopify:section:load', (event) => {
  const container = event.target.querySelector('.image-slider');
  if (container) {
    container.dataset.sliderInitialized = '';
    new ImageSlider(container);
  }
});